// Shared employee_timetable helpers — used by the Leave tab (type ลากิจ/ลาป่วย/
// Leave without pay) and available to Clock-in. Pure: enums + month math + display meta, no I/O.
// Backend table: employee_timetable (55). Access via /api/hr/leave (+ /api/hr/clockin).

// All timetable row types (verbatim from the Xano enum).
export const TIMETABLE_TYPES = [
  'กะเช้า', 'กะบ่าย', 'เวรผู้ช่วย', 'WFH', 'ลากิจ', 'ลาป่วย', 'กะควบ', 'Office',
  'Leave without pay',
]

// The "leave" row types the Leave tab owns — a day the person is NOT working.
export const LEAVE_PERSONAL = 'ลากิจ' // personal leave
export const LEAVE_SICK = 'ลาป่วย'    // sick leave
// Unpaid leave (Ram, 2026-10-31). A day off that is NOT counted against the
// ลากิจ quota — the day's pay (Base Salary ÷ 30) is deducted instead, and it
// forfeits เบี้ยขยัน like any leave. Manager/HR/Admin record it on the roster or
// the การลา tab; it is deliberately absent from the employee's ขอลา form
// (MeLeave + /api/me/leave keep their own ลากิจ/ลาป่วย list).
export const LEAVE_UNPAID = 'Leave without pay'
export const LEAVE_TYPES = [LEAVE_PERSONAL, LEAVE_SICK, LEAVE_UNPAID]

export const isLeaveType = (t) => LEAVE_TYPES.includes(t)

// Label + pill tone for a leave type (matches the app's ring-pill convention).
export function leaveTypeMeta(type) {
  if (type === LEAVE_SICK) return { label: 'ลาป่วย', short: 'ป่วย', tone: 'bg-rose-50 text-rose-700 ring-rose-200' }
  if (type === LEAVE_UNPAID) return { label: 'Leave without pay', short: 'LWP', tone: 'bg-stone-200 text-stone-700 ring-stone-300' }
  return { label: 'ลากิจ', short: 'กิจ', tone: 'bg-amber-50 text-amber-700 ring-amber-200' }
}

export const MONTHS_TH = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
]
export const MONTHS_TH_SHORT = [
  'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
  'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.',
]

const pad2 = (n) => String(n).padStart(2, '0')

// { year, month(1-12) } for "now" — the default period for month-oriented tabs.
export function nowYM() {
  const d = new Date()
  return { year: d.getFullYear(), month: d.getMonth() + 1 }
}

// Calendar-month ISO date range for a GET ?start_date&end_date filter.
// month is 1-12. Returns inclusive first→last day as 'YYYY-MM-DD' strings.
export function monthRange(year, month) {
  const last = new Date(year, month, 0).getDate() // day 0 of next month = last day
  return { start_date: `${year}-${pad2(month)}-01`, end_date: `${year}-${pad2(month)}-${pad2(last)}` }
}

// "สิงหาคม 2569" — Buddhist-era label for a month/year (year passed as CE).
export function fmtMonthTH(year, month) {
  const m = MONTHS_TH[(month - 1 + 12) % 12] || ''
  return `${m} ${Number(year) + 543}`
}

// Step a { year, month } by ±1 month, rolling the year.
export function stepMonth({ year, month }, delta) {
  const idx = (year * 12 + (month - 1)) + delta
  return { year: Math.floor(idx / 12), month: (idx % 12) + 1 }
}
